import { render, staticRenderFns } from "./FengXiang.vue?vue&type=template&id=5816bbca&scoped=true"
import script from "./FengXiang.vue?vue&type=script&lang=js"
export * from "./FengXiang.vue?vue&type=script&lang=js"
import style0 from "./FengXiang.vue?vue&type=style&index=0&id=5816bbca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5816bbca",
  null
  
)

export default component.exports